module.exports = __webpack_public_path__ + "static/media/박민우.9db7cc2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/박민우.png
// module id = 101
// module chunks = 0